import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../utils.ts';

interface SpinnerProps extends ComponentPropsWithoutRef<'span'> {
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: 'h-3.5 w-3.5 border-[1.5px]',
  md: 'h-4 w-4 border-2',
  lg: 'h-5 w-5 border-2',
} satisfies Record<'sm' | 'md' | 'lg', string>;

export function Spinner({ size = 'md', className, ...rest }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block rounded-full border-current border-r-transparent animate-spin motion-reduce:animate-none',
        sizes[size],
        className,
      )}
      {...rest}
    />
  );
}
